var map = {
	"./de@2x.png": "2ca8",
	"./en@2x.png": "b3d2",
	"./es@2x.png": "6829",
	"./fr@2x.png": "0290",
	"./it@2x.png": "6810",
	"./jp@2x.png": "450d",
	"./ru@2x.png": "bc94"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b2b7";